module.exports = __webpack_public_path__ + "static/media/sumimoto-mobiles.9224a95f.jpg";